import { IDatabaseItem } from "../interfaces";

export const MEDICAL_ITEMS: Array<IDatabaseItem> = [
	{
		title: "Dr. Max Vitamin C Imuno Akut 700 mg 30 kapslí",
		price: 169,
		images: [{
			src: "01.webp",
			large: "01.webp",
		}],
	},
	{
		title: "Rowachol - žlučník",
		images: [{
			src: "02.webp",
			large: "02.webp",
		}],
	},
];
